import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapState } from 'vuex'
import draggable from 'vuedraggable'
import { BRow, BCol, BFormGroup, BButton, BNav, BNavItem, VBTooltip } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { PageHeader, TeamUserSelect, Spinner, AppMessages } from '@kwixeo/interface-vue'
import { KFormPeriodSelect } from '@kwixeo/form-vue'
import Dashboard from '../Dashboard/Dashboard.vue'
import DashboardForm from '../DashboardForm/DashboardForm.vue'

@Component({
  components: {
    KFormPeriodSelect,
    Dashboard, DashboardForm,
    PageHeader, TeamUserSelect, Spinner, AppMessages,
    BRow, BCol, BFormGroup, BButton, BNav, BNavItem,
    FontAwesomeIcon,
    draggable
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  methods: {
    ...mapActions('dashboard', ['loadDashboards', 'loadWidgets'])
  },
  computed: {
    ...mapState('dashboard', ['dashboards']),
    ...mapGetters('user', ['teamUser', 'can'])
  }
})
export default class Dashboards extends Vue {
  loadDashboards!: (force?: boolean) => void
  loadWidgets!: (force?: boolean) => void
  dashboards!: KwixeoDashboard.Dashboards
  teamUser!: KwixeoFramework.TeamUser
  can!: (key: string, level: number) => boolean

  private loading = true

  private editionMode = false
  private addDashboard = false

  private preset: string|null = null
  private begin: string|null = null
  private end: string|null = null

  private compare = false
  private presetCompare: string|null = null
  private beginCompare: string|null = null
  private endCompare: string|null = null

  private period: KwixeoForm.DateRangeDatas|null = null
  private teamUsers: number[] = []
  private selectedDashboard: number|null = null
  private redirectDashboard: null|number = null

  async mounted (): Promise<void> {
    await this.initializeDashboards()
  }

  @Watch('teamUser', { deep: true })
  private async watchTeamUser (): Promise<void> {
    await this.initializeDashboards()
  }

  get dashboard (): KwixeoDashboard.Dashboard|null {
    return this.dashboards.find(dashboard => dashboard.id === this.selectedDashboard) ?? this.dashboards[0] ?? null
  }

  get filters (): KwixeoInterface.GenericObject {
    const filters: KwixeoInterface.GenericObject = {
      begin: this.period?.begin,
      end: this.period?.end,
      teamUsers: this.teamUsers
    }
    if (this.period?.compare) {
      filters['beginCompare'] = this.period?.beginCompare
      filters['endCompare'] = this.period?.endCompare
    }
    return filters
  }

  private paramsUpdated (): void {
    this.saveParams()
  }

  private dashboardOrdered (): void {
    //
  }

  private saveParams (): void {
    window.localStorage.setItem('dashboard-' + this.teamUser.id, JSON.stringify({
      period: this.period,
      teamUsers: this.teamUsers,
      selectedDashboard: this.selectedDashboard
    }))
  }

  private dashboardCreated (dashboard: KwixeoDashboard.Dashboard): void {
    const index = this.dashboards.findIndex(val => val.id === dashboard.id)
    if (index >= 0) {
      this.redirectDashboard = index
    }
  }

  private dashboardsUpdated (): void {
    if (this.redirectDashboard) {
      this.selectedDashboard = this.redirectDashboard
      this.redirectDashboard = null
    }
  }

  private dashboardDeleted (): void {
    this.selectedDashboard = this.selectedDashboard ? this.selectedDashboard - 1 : 0
    this.saveParams()
  }

  private async initializeDashboards (): Promise<void> {
    this.loading = true
    await this.loadDashboards()
    await this.loadWidgets()
    this.loading = false

    this.editionMode = this.dashboards.length === 0

    const storage = window.localStorage.getItem('dashboard-' + this.teamUser.id)
    let config: KwixeoDashboard.StorageDashboardConfig = {}
    if (storage) {
      config = JSON.parse(storage)
    }

    this.period = config.period ?? null
    this.selectedDashboard = config.selectedDashboard ?? this.dashboard?.id ?? null

    if (config.teamUsers) {
      this.teamUsers = config.teamUsers
    }
  }

  private filterTeamUser (user: KwixeoFramework.TeamUser): boolean {
    return this.can('sales-datas', 2) || user.id === this.teamUser.id
  }

  private updateDates (data: KwixeoForm.DateRangeDatas): void {
    this.period = data
    this.saveParams()
  }
}
